<template>
  <ul v-if="items.length" class="-mx-6 sm:-mx-8 md:mx-0 lg:-mx-6">
    <li v-for="(item, itemIndex) of items" :key="`${item.slot}#${itemIndex}`" class="bg-app-green-100 border-t-2 border-solid border-app-green-100 md:bg-white">
      <h3 class="flex items-center p-4 font-bold cursor-pointer md:px-8" @click="toggle(item)">
        <AtomIcon v-if="item.icon" :icon="item.icon" class="shrink-0 w-5 h-5 text-app-green mr-6 lg:mr-8" />
        <span class="text-black flex-auto font-semibold">
          <strong v-if="showAsSteps" class="font-bold">{{ t_('step', { step: itemIndex + 1 }) }}:</strong>
          {{ item.label }}
        </span>
        <AtomIconChevronDown class="shrink-0 ml-2 w-5 h-5 text-app-green transition duration-200 ease-in-out" :class="{ 'transform rotate-180': isOpen(item) }" />
      </h3>
      <SmoothReflow class="m-0 p-0 overflow-hidden transition-all duration-200 ease-in-out">
        <div :class="{ 'h-auto pb-3': isOpen(item), 'h-0': !isOpen(item) }">
          <div class="p-4 md:p-8">
            <slot :name="item.slot" :item="item" />
          </div>
        </div>
      </SmoothReflow>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import xor from 'lodash/xor'
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  showAsSteps: boolean
  items: Array<{ slot: string; label: string; icon?: string; isInitiallyOpen?: boolean }>
}

const props = defineProps<Props>()

const states = ref(props.items.map((item) => (item.isInitiallyOpen ? item.slot : undefined)).filter((slot) => !!slot))

const toggle = (item: { slot: string }) => {
  states.value = xor(states.value, [item.slot])
}

const isOpen = (item: { slot: string }) => states.value.includes(item.slot)

const { t_ } = setupTranslationPrefixer('AnimalDetailBlocks')
</script>
